export default __webpack_public_path__ + "static/media/Triton waiting room.308bf0bf.jpg";